<span
  [closeDelay]="closeDelay"
  [ngbTooltip]="tooltipText"
  [openDelay]="openDelay"
  [placement]="placement"
  class="icon-tooltip-2"
  container="body"
  ><i class="fa fa-question-circle"></i
></span>
